export const SET_PAYMENT_HISTORY_LIST = 'SET_PAYMENT_HISTORY_LIST'
export const FETCH_PAYMENT_HISTORY_LIST_STATUS = 'FETCH_PAYMENT_HISTORY_LIST_STATUS'

export const SET_PAYMENT_HISTORY_ROUTE_PARAMS = 'SET_PAYMENT_HISTORY_ROUTE_PARAMS'

export const FETCH_PAYMENT_HISTORY_SUM_DATA_STATUS = 'FETCH_PAYMENT_HISTORY_SUM_DATA_STATUS'
export const SET_PAYMENT_HISTORY_SUM_DATA = 'SET_PAYMENT_HISTORY_SUM_DATA'
